const { is }     = require('../../is/is')
const { Object } = require('../../Object/Object')

const { sample } = require('./sample')

/**
 * Egy elem véletlenszerű kiválasztása a tömbből, kivéve lehetőséggel.
 * @template T
 * @param {readonly T[]} array - A tömbünk.
 * @param {T | readonly T[]} except - Kivéve.
 * @returns {T | null} Véletlenszerűen kiválasztott.
 */
function sampleExcept (array, except) {
  const exceptArray = is.array(except) ? except : [ except ]

  const correctSamples = array.filter((sampleValue) => {
    return exceptArray.every((expectValue) => !Object.isEqualWith(sampleValue, expectValue))
  })

  if (is.empty(correctSamples)) {
    return null
  }

  return sample(correctSamples)
}

module.exports.sampleExcept = sampleExcept
